import {
  FieldText,
  FormField,
  FormGrid,
  HelperField,
} from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';
import { Field, WrappedFieldProps } from 'redux-form';

import styles from './timeoutFields.module.scss';

type TimeoutInputPropsT = {
  max: number;
  min: number;
  placeholder: string;
  suffix: string;
} & WrappedFieldProps;

const TimeoutInput = ({
  input,
  max,
  min,
  placeholder,
  suffix,
}: TimeoutInputPropsT): ReactNode => {
  return (
    <FieldText
      input={input}
      max={max}
      min={min}
      noAlert
      noLabel
      placeholder={placeholder}
      suffix={suffix}
      type="number"
    />
  );
};

export const TimeoutFields = ({
  input,
  meta,
}: WrappedFieldProps): ReactNode => {
  const { name } = input;
  const { error, touched } = meta;

  return (
    <>
      <FormGrid>
        <FormField span={2}>
          <Field
            component={TimeoutInput}
            max={9999}
            min={0}
            name={`${name}.dd`}
            suffix="Days"
            placeholder="E.g. 1"
          />
        </FormField>
        <FormField span={2}>
          <Field
            component={TimeoutInput}
            max={23}
            min={0}
            name={`${name}.hh`}
            suffix="Hours"
            placeholder="E.g. 4"
          />
        </FormField>
        <FormField span={2}>
          <Field
            component={TimeoutInput}
            max={59}
            min={0}
            name={`${name}.mm`}
            suffix="Minutes"
            placeholder="E.g. 5"
          />
        </FormField>
      </FormGrid>
      <HelperField
        className={styles.helperField}
        errorMessage={touched && error}
        fieldId="timeout"
      >
        <></>
      </HelperField>
    </>
  );
};
